/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAdministrator = /* GraphQL */ `query GetAdministrator($id: ID!) {
  getAdministrator(id: $id) {
    id
    username
    status
    role
    firstName
    middleName
    lastName
    email
    phone
    address
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdministratorQueryVariables,
  APITypes.GetAdministratorQuery
>;
export const listAdministrators = /* GraphQL */ `query ListAdministrators(
  $filter: ModelAdministratorFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdministrators(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      status
      role
      firstName
      middleName
      lastName
      email
      phone
      address
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdministratorsQueryVariables,
  APITypes.ListAdministratorsQuery
>;
export const syncAdministrators = /* GraphQL */ `query SyncAdministrators(
  $filter: ModelAdministratorFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdministrators(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      username
      status
      role
      firstName
      middleName
      lastName
      email
      phone
      address
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdministratorsQueryVariables,
  APITypes.SyncAdministratorsQuery
>;
export const getAdministratorApprovers = /* GraphQL */ `query GetAdministratorApprovers($id: ID!) {
  getAdministratorApprovers(id: $id) {
    id
    userID
    editor
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdministratorApproversQueryVariables,
  APITypes.GetAdministratorApproversQuery
>;
export const listAdministratorApprovers = /* GraphQL */ `query ListAdministratorApprovers(
  $filter: ModelAdministratorApproversFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdministratorApprovers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      editor
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdministratorApproversQueryVariables,
  APITypes.ListAdministratorApproversQuery
>;
export const syncAdministratorApprovers = /* GraphQL */ `query SyncAdministratorApprovers(
  $filter: ModelAdministratorApproversFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdministratorApprovers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      editor
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdministratorApproversQueryVariables,
  APITypes.SyncAdministratorApproversQuery
>;
export const getAffiliate = /* GraphQL */ `query GetAffiliate($id: ID!) {
  getAffiliate(id: $id) {
    id
    firstName
    middleName
    lastName
    email
    phone
    company
    address
    notes
    code
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAffiliateQueryVariables,
  APITypes.GetAffiliateQuery
>;
export const listAffiliates = /* GraphQL */ `query ListAffiliates(
  $filter: ModelAffiliateFilterInput
  $limit: Int
  $nextToken: String
) {
  listAffiliates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      firstName
      middleName
      lastName
      email
      phone
      company
      address
      notes
      code
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAffiliatesQueryVariables,
  APITypes.ListAffiliatesQuery
>;
export const syncAffiliates = /* GraphQL */ `query SyncAffiliates(
  $filter: ModelAffiliateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAffiliates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      firstName
      middleName
      lastName
      email
      phone
      company
      address
      notes
      code
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAffiliatesQueryVariables,
  APITypes.SyncAffiliatesQuery
>;
export const getAffiliateEarning = /* GraphQL */ `query GetAffiliateEarning($id: ID!) {
  getAffiliateEarning(id: $id) {
    id
    affiliateID
    linkID
    milestoneKey
    amountCents
    status
    payoutID
    idempotencyKey
    occurredAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAffiliateEarningQueryVariables,
  APITypes.GetAffiliateEarningQuery
>;
export const listAffiliateEarnings = /* GraphQL */ `query ListAffiliateEarnings(
  $filter: ModelAffiliateEarningFilterInput
  $limit: Int
  $nextToken: String
) {
  listAffiliateEarnings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      affiliateID
      linkID
      milestoneKey
      amountCents
      status
      payoutID
      idempotencyKey
      occurredAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAffiliateEarningsQueryVariables,
  APITypes.ListAffiliateEarningsQuery
>;
export const syncAffiliateEarnings = /* GraphQL */ `query SyncAffiliateEarnings(
  $filter: ModelAffiliateEarningFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAffiliateEarnings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      affiliateID
      linkID
      milestoneKey
      amountCents
      status
      payoutID
      idempotencyKey
      occurredAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAffiliateEarningsQueryVariables,
  APITypes.SyncAffiliateEarningsQuery
>;
export const getAffiliateLink = /* GraphQL */ `query GetAffiliateLink($id: ID!) {
  getAffiliateLink(id: $id) {
    id
    ownerID
    ownerType
    affiliateID
    affiliateCode
    attributedAt
    migratedToOrganizationID
    createdByUserID
    milestones
    unitCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAffiliateLinkQueryVariables,
  APITypes.GetAffiliateLinkQuery
>;
export const listAffiliateLinks = /* GraphQL */ `query ListAffiliateLinks(
  $filter: ModelAffiliateLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  listAffiliateLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      ownerID
      ownerType
      affiliateID
      affiliateCode
      attributedAt
      migratedToOrganizationID
      createdByUserID
      milestones
      unitCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAffiliateLinksQueryVariables,
  APITypes.ListAffiliateLinksQuery
>;
export const syncAffiliateLinks = /* GraphQL */ `query SyncAffiliateLinks(
  $filter: ModelAffiliateLinkFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAffiliateLinks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      ownerID
      ownerType
      affiliateID
      affiliateCode
      attributedAt
      migratedToOrganizationID
      createdByUserID
      milestones
      unitCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAffiliateLinksQueryVariables,
  APITypes.SyncAffiliateLinksQuery
>;
export const getAffiliateMilestoneRate = /* GraphQL */ `query GetAffiliateMilestoneRate($id: ID!) {
  getAffiliateMilestoneRate(id: $id) {
    id
    milestoneKey
    amountCents
    affiliateID
    currency
    effectiveFrom
    effectiveTo
    isActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAffiliateMilestoneRateQueryVariables,
  APITypes.GetAffiliateMilestoneRateQuery
>;
export const listAffiliateMilestoneRates = /* GraphQL */ `query ListAffiliateMilestoneRates(
  $filter: ModelAffiliateMilestoneRateFilterInput
  $limit: Int
  $nextToken: String
) {
  listAffiliateMilestoneRates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      milestoneKey
      amountCents
      affiliateID
      currency
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAffiliateMilestoneRatesQueryVariables,
  APITypes.ListAffiliateMilestoneRatesQuery
>;
export const syncAffiliateMilestoneRates = /* GraphQL */ `query SyncAffiliateMilestoneRates(
  $filter: ModelAffiliateMilestoneRateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAffiliateMilestoneRates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      milestoneKey
      amountCents
      affiliateID
      currency
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAffiliateMilestoneRatesQueryVariables,
  APITypes.SyncAffiliateMilestoneRatesQuery
>;
export const getAffiliatePayout = /* GraphQL */ `query GetAffiliatePayout($id: ID!) {
  getAffiliatePayout(id: $id) {
    id
    affiliateID
    status
    grossCents
    generatedAt
    paidAt
    paymentRef
    notes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAffiliatePayoutQueryVariables,
  APITypes.GetAffiliatePayoutQuery
>;
export const listAffiliatePayouts = /* GraphQL */ `query ListAffiliatePayouts(
  $filter: ModelAffiliatePayoutFilterInput
  $limit: Int
  $nextToken: String
) {
  listAffiliatePayouts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      affiliateID
      status
      grossCents
      generatedAt
      paidAt
      paymentRef
      notes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAffiliatePayoutsQueryVariables,
  APITypes.ListAffiliatePayoutsQuery
>;
export const syncAffiliatePayouts = /* GraphQL */ `query SyncAffiliatePayouts(
  $filter: ModelAffiliatePayoutFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAffiliatePayouts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      affiliateID
      status
      grossCents
      generatedAt
      paidAt
      paymentRef
      notes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAffiliatePayoutsQueryVariables,
  APITypes.SyncAffiliatePayoutsQuery
>;
export const getAffiliateVisit = /* GraphQL */ `query GetAffiliateVisit($id: ID!) {
  getAffiliateVisit(id: $id) {
    id
    affiliateID
    affiliateCode
    visitedAt
    path
    userAgent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAffiliateVisitQueryVariables,
  APITypes.GetAffiliateVisitQuery
>;
export const listAffiliateVisits = /* GraphQL */ `query ListAffiliateVisits(
  $filter: ModelAffiliateVisitFilterInput
  $limit: Int
  $nextToken: String
) {
  listAffiliateVisits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      affiliateID
      affiliateCode
      visitedAt
      path
      userAgent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAffiliateVisitsQueryVariables,
  APITypes.ListAffiliateVisitsQuery
>;
export const syncAffiliateVisits = /* GraphQL */ `query SyncAffiliateVisits(
  $filter: ModelAffiliateVisitFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAffiliateVisits(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      affiliateID
      affiliateCode
      visitedAt
      path
      userAgent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAffiliateVisitsQueryVariables,
  APITypes.SyncAffiliateVisitsQuery
>;
export const getAmenity = /* GraphQL */ `query GetAmenity($id: ID!) {
  getAmenity(id: $id) {
    id
    propertyID
    name
    userID
    ownerID
    ownerType
    reservationRule {
      policy
      userID
      ownerID
      ownerType
      requiresApproval
      maxDuration
      minDuration
      furthestTime
      closestTime
      maxPartySize
      maxRequests
      __typename
    }
    description
    rules
    availability
    geolocation
    locationDescription
    buildingID
    images
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAmenityQueryVariables,
  APITypes.GetAmenityQuery
>;
export const listAmenities = /* GraphQL */ `query ListAmenities(
  $filter: ModelAmenityFilterInput
  $limit: Int
  $nextToken: String
) {
  listAmenities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      propertyID
      name
      userID
      ownerID
      ownerType
      reservationRule {
        policy
        userID
        ownerID
        ownerType
        requiresApproval
        maxDuration
        minDuration
        furthestTime
        closestTime
        maxPartySize
        maxRequests
        __typename
      }
      description
      rules
      availability
      geolocation
      locationDescription
      buildingID
      images
      lockUnixTTL
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAmenitiesQueryVariables,
  APITypes.ListAmenitiesQuery
>;
export const syncAmenities = /* GraphQL */ `query SyncAmenities(
  $filter: ModelAmenityFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAmenities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyID
      name
      userID
      ownerID
      ownerType
      reservationRule {
        policy
        userID
        ownerID
        ownerType
        requiresApproval
        maxDuration
        minDuration
        furthestTime
        closestTime
        maxPartySize
        maxRequests
        __typename
      }
      description
      rules
      availability
      geolocation
      locationDescription
      buildingID
      images
      lockUnixTTL
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAmenitiesQueryVariables,
  APITypes.SyncAmenitiesQuery
>;
export const getAmenityReservation = /* GraphQL */ `query GetAmenityReservation($id: ID!) {
  getAmenityReservation(id: $id) {
    id
    amenityID
    tenantID
    startDate
    userID
    ownerID
    ownerType
    details
    status
    statusReason
    endDate
    reviewer
    partySize
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAmenityReservationQueryVariables,
  APITypes.GetAmenityReservationQuery
>;
export const listAmenityReservations = /* GraphQL */ `query ListAmenityReservations(
  $filter: ModelAmenityReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAmenityReservations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      amenityID
      tenantID
      startDate
      userID
      ownerID
      ownerType
      details
      status
      statusReason
      endDate
      reviewer
      partySize
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAmenityReservationsQueryVariables,
  APITypes.ListAmenityReservationsQuery
>;
export const syncAmenityReservations = /* GraphQL */ `query SyncAmenityReservations(
  $filter: ModelAmenityReservationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAmenityReservations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      amenityID
      tenantID
      startDate
      userID
      ownerID
      ownerType
      details
      status
      statusReason
      endDate
      reviewer
      partySize
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAmenityReservationsQueryVariables,
  APITypes.SyncAmenityReservationsQuery
>;
export const getApplication = /* GraphQL */ `query GetApplication($id: ID!) {
  getApplication(id: $id) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    moveInDatePreference
    rentPaymentPreference
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetApplicationQueryVariables,
  APITypes.GetApplicationQuery
>;
export const listApplications = /* GraphQL */ `query ListApplications(
  $filter: ModelApplicationFilterInput
  $limit: Int
  $nextToken: String
) {
  listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      userID
      ownerID
      ownerType
      startDate
      endDate
      moveInDatePreference
      rentPaymentPreference
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListApplicationsQueryVariables,
  APITypes.ListApplicationsQuery
>;
export const syncApplications = /* GraphQL */ `query SyncApplications(
  $filter: ModelApplicationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncApplications(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      status
      userID
      ownerID
      ownerType
      startDate
      endDate
      moveInDatePreference
      rentPaymentPreference
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncApplicationsQueryVariables,
  APITypes.SyncApplicationsQuery
>;
export const getBackgroundCheck = /* GraphQL */ `query GetBackgroundCheck($id: ID!) {
  getBackgroundCheck(id: $id) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBackgroundCheckQueryVariables,
  APITypes.GetBackgroundCheckQuery
>;
export const listBackgroundChecks = /* GraphQL */ `query ListBackgroundChecks(
  $filter: ModelBackgroundCheckFilterInput
  $limit: Int
  $nextToken: String
) {
  listBackgroundChecks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      userID
      ownerID
      ownerType
      startDate
      endDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBackgroundChecksQueryVariables,
  APITypes.ListBackgroundChecksQuery
>;
export const syncBackgroundChecks = /* GraphQL */ `query SyncBackgroundChecks(
  $filter: ModelBackgroundCheckFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBackgroundChecks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      status
      userID
      ownerID
      ownerType
      startDate
      endDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBackgroundChecksQueryVariables,
  APITypes.SyncBackgroundChecksQuery
>;
export const getBuilding = /* GraphQL */ `query GetBuilding($id: ID!) {
  getBuilding(id: $id) {
    id
    status
    propertyID
    name
    userID
    ownerID
    ownerType
    description
    rent
    price
    numBedroom
    numBathroom
    actualRentPaymentDate
    size
    street
    type
    contact
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBuildingQueryVariables,
  APITypes.GetBuildingQuery
>;
export const listBuildings = /* GraphQL */ `query ListBuildings(
  $filter: ModelBuildingFilterInput
  $limit: Int
  $nextToken: String
) {
  listBuildings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      propertyID
      name
      userID
      ownerID
      ownerType
      description
      rent
      price
      numBedroom
      numBathroom
      actualRentPaymentDate
      size
      street
      type
      contact
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBuildingsQueryVariables,
  APITypes.ListBuildingsQuery
>;
export const syncBuildings = /* GraphQL */ `query SyncBuildings(
  $filter: ModelBuildingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBuildings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      status
      propertyID
      name
      userID
      ownerID
      ownerType
      description
      rent
      price
      numBedroom
      numBathroom
      actualRentPaymentDate
      size
      street
      type
      contact
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBuildingsQueryVariables,
  APITypes.SyncBuildingsQuery
>;
export const getCharges = /* GraphQL */ `query GetCharges($id: ID!) {
  getCharges(id: $id) {
    id
    type
    isRevenue
    userID
    ownerID
    ownerType
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChargesQueryVariables,
  APITypes.GetChargesQuery
>;
export const listCharges = /* GraphQL */ `query ListCharges(
  $filter: ModelChargesFilterInput
  $limit: Int
  $nextToken: String
) {
  listCharges(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      isRevenue
      userID
      ownerID
      ownerType
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChargesQueryVariables,
  APITypes.ListChargesQuery
>;
export const syncCharges = /* GraphQL */ `query SyncCharges(
  $filter: ModelChargesFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCharges(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      type
      isRevenue
      userID
      ownerID
      ownerType
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncChargesQueryVariables,
  APITypes.SyncChargesQuery
>;
export const getComments = /* GraphQL */ `query GetComments($id: ID!) {
  getComments(id: $id) {
    id
    commenter
    text
    userID
    ownerID
    ownerType
    createdDate
    parentID
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommentsQueryVariables,
  APITypes.GetCommentsQuery
>;
export const listComments = /* GraphQL */ `query ListComments(
  $filter: ModelCommentsFilterInput
  $limit: Int
  $nextToken: String
) {
  listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      commenter
      text
      userID
      ownerID
      ownerType
      createdDate
      parentID
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommentsQueryVariables,
  APITypes.ListCommentsQuery
>;
export const syncComments = /* GraphQL */ `query SyncComments(
  $filter: ModelCommentsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncComments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      commenter
      text
      userID
      ownerID
      ownerType
      createdDate
      parentID
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCommentsQueryVariables,
  APITypes.SyncCommentsQuery
>;
export const getEntityField = /* GraphQL */ `query GetEntityField($id: ID!) {
  getEntityField(id: $id) {
    id
    entityID
    entityType
    name
    type
    userID
    ownerID
    ownerType
    value
    date
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntityFieldQueryVariables,
  APITypes.GetEntityFieldQuery
>;
export const listEntityFields = /* GraphQL */ `query ListEntityFields(
  $filter: ModelEntityFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listEntityFields(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entityID
      entityType
      name
      type
      userID
      ownerID
      ownerType
      value
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEntityFieldsQueryVariables,
  APITypes.ListEntityFieldsQuery
>;
export const syncEntityFields = /* GraphQL */ `query SyncEntityFields(
  $filter: ModelEntityFieldFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEntityFields(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityID
      entityType
      name
      type
      userID
      ownerID
      ownerType
      value
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEntityFieldsQueryVariables,
  APITypes.SyncEntityFieldsQuery
>;
export const getEvent = /* GraphQL */ `query GetEvent($id: ID!) {
  getEvent(id: $id) {
    id
    entityType
    entityID
    ownerID
    ownerType
    name
    date
    type
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEventQueryVariables, APITypes.GetEventQuery>;
export const listEvents = /* GraphQL */ `query ListEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entityType
      entityID
      ownerID
      ownerType
      name
      date
      type
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventsQueryVariables,
  APITypes.ListEventsQuery
>;
export const syncEvents = /* GraphQL */ `query SyncEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEvents(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityType
      entityID
      ownerID
      ownerType
      name
      date
      type
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEventsQueryVariables,
  APITypes.SyncEventsQuery
>;
export const getFavorite = /* GraphQL */ `query GetFavorite($id: ID!) {
  getFavorite(id: $id) {
    id
    userID
    ownerID
    ownerType
    favType
    favID
    image
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFavoriteQueryVariables,
  APITypes.GetFavoriteQuery
>;
export const listFavorites = /* GraphQL */ `query ListFavorites(
  $filter: ModelFavoriteFilterInput
  $limit: Int
  $nextToken: String
) {
  listFavorites(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      ownerID
      ownerType
      favType
      favID
      image
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFavoritesQueryVariables,
  APITypes.ListFavoritesQuery
>;
export const syncFavorites = /* GraphQL */ `query SyncFavorites(
  $filter: ModelFavoriteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncFavorites(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      ownerID
      ownerType
      favType
      favID
      image
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncFavoritesQueryVariables,
  APITypes.SyncFavoritesQuery
>;
export const getFinanceLock = /* GraphQL */ `query GetFinanceLock($id: ID!) {
  getFinanceLock(id: $id) {
    id
    scope
    ownerID
    ownerType
    entityID
    entityType
    year
    month
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFinanceLockQueryVariables,
  APITypes.GetFinanceLockQuery
>;
export const listFinanceLocks = /* GraphQL */ `query ListFinanceLocks(
  $filter: ModelFinanceLockFilterInput
  $limit: Int
  $nextToken: String
) {
  listFinanceLocks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      scope
      ownerID
      ownerType
      entityID
      entityType
      year
      month
      lockUnixTTL
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFinanceLocksQueryVariables,
  APITypes.ListFinanceLocksQuery
>;
export const syncFinanceLocks = /* GraphQL */ `query SyncFinanceLocks(
  $filter: ModelFinanceLockFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncFinanceLocks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      scope
      ownerID
      ownerType
      entityID
      entityType
      year
      month
      lockUnixTTL
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncFinanceLocksQueryVariables,
  APITypes.SyncFinanceLocksQuery
>;
export const getJoinOrganizationRequest = /* GraphQL */ `query GetJoinOrganizationRequest($id: ID!) {
  getJoinOrganizationRequest(id: $id) {
    id
    userID
    requestStatus
    organizationID
    requestPropertyTransfer
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJoinOrganizationRequestQueryVariables,
  APITypes.GetJoinOrganizationRequestQuery
>;
export const listJoinOrganizationRequests = /* GraphQL */ `query ListJoinOrganizationRequests(
  $filter: ModelJoinOrganizationRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  listJoinOrganizationRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      requestStatus
      organizationID
      requestPropertyTransfer
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJoinOrganizationRequestsQueryVariables,
  APITypes.ListJoinOrganizationRequestsQuery
>;
export const syncJoinOrganizationRequests = /* GraphQL */ `query SyncJoinOrganizationRequests(
  $filter: ModelJoinOrganizationRequestFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncJoinOrganizationRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      requestStatus
      organizationID
      requestPropertyTransfer
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncJoinOrganizationRequestsQueryVariables,
  APITypes.SyncJoinOrganizationRequestsQuery
>;
export const getLease = /* GraphQL */ `query GetLease($id: ID!) {
  getLease(id: $id) {
    id
    entityType
    entityID
    type
    status
    userID
    ownerID
    ownerType
    tenantID
    startDate
    endDate
    markedDate
    extraOccupants
    applicationID
    backgroundCheckID
    offerID
    moveInID
    moveOutID
    nextLeaseID
    prevLeaseID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLeaseQueryVariables, APITypes.GetLeaseQuery>;
export const listLeases = /* GraphQL */ `query ListLeases(
  $filter: ModelLeaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listLeases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entityType
      entityID
      type
      status
      userID
      ownerID
      ownerType
      tenantID
      startDate
      endDate
      markedDate
      extraOccupants
      applicationID
      backgroundCheckID
      offerID
      moveInID
      moveOutID
      nextLeaseID
      prevLeaseID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLeasesQueryVariables,
  APITypes.ListLeasesQuery
>;
export const syncLeases = /* GraphQL */ `query SyncLeases(
  $filter: ModelLeaseFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncLeases(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityType
      entityID
      type
      status
      userID
      ownerID
      ownerType
      tenantID
      startDate
      endDate
      markedDate
      extraOccupants
      applicationID
      backgroundCheckID
      offerID
      moveInID
      moveOutID
      nextLeaseID
      prevLeaseID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncLeasesQueryVariables,
  APITypes.SyncLeasesQuery
>;
export const getMessage = /* GraphQL */ `query GetMessage($id: ID!) {
  getMessage(id: $id) {
    id
    title
    content
    userID
    ownerID
    ownerType
    senderID
    senderName
    receiverID
    receiverName
    messageTitle
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageQueryVariables,
  APITypes.GetMessageQuery
>;
export const listMessages = /* GraphQL */ `query ListMessages(
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      content
      userID
      ownerID
      ownerType
      senderID
      senderName
      receiverID
      receiverName
      messageTitle
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessagesQueryVariables,
  APITypes.ListMessagesQuery
>;
export const syncMessages = /* GraphQL */ `query SyncMessages(
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncMessages(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      title
      content
      userID
      ownerID
      ownerType
      senderID
      senderName
      receiverID
      receiverName
      messageTitle
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncMessagesQueryVariables,
  APITypes.SyncMessagesQuery
>;
export const getMonthlyFinanceReport = /* GraphQL */ `query GetMonthlyFinanceReport($id: ID!) {
  getMonthlyFinanceReport(id: $id) {
    id
    yearlyReportId
    month
    year
    userID
    ownerID
    ownerType
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonthlyFinanceReportQueryVariables,
  APITypes.GetMonthlyFinanceReportQuery
>;
export const listMonthlyFinanceReports = /* GraphQL */ `query ListMonthlyFinanceReports(
  $filter: ModelMonthlyFinanceReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonthlyFinanceReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      yearlyReportId
      month
      year
      userID
      ownerID
      ownerType
      entityID
      entityType
      income {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonthlyFinanceReportsQueryVariables,
  APITypes.ListMonthlyFinanceReportsQuery
>;
export const syncMonthlyFinanceReports = /* GraphQL */ `query SyncMonthlyFinanceReports(
  $filter: ModelMonthlyFinanceReportFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncMonthlyFinanceReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      yearlyReportId
      month
      year
      userID
      ownerID
      ownerType
      entityID
      entityType
      income {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncMonthlyFinanceReportsQueryVariables,
  APITypes.SyncMonthlyFinanceReportsQuery
>;
export const getMonthlyStatusReport = /* GraphQL */ `query GetMonthlyStatusReport($id: ID!) {
  getMonthlyStatusReport(id: $id) {
    id
    entityID
    entityType
    month
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonthlyStatusReportQueryVariables,
  APITypes.GetMonthlyStatusReportQuery
>;
export const listMonthlyStatusReports = /* GraphQL */ `query ListMonthlyStatusReports(
  $filter: ModelMonthlyStatusReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonthlyStatusReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      entityID
      entityType
      month
      year
      numOccupied
      numVacant
      numRenovation
      numUnits
      numBuildings
      numProperties
      numServiceRequests
      numAmenities
      numAmenityReservations
      expectedRent
      expectedStayRevenue
      aggregateIncome {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonthlyStatusReportsQueryVariables,
  APITypes.ListMonthlyStatusReportsQuery
>;
export const syncMonthlyStatusReports = /* GraphQL */ `query SyncMonthlyStatusReports(
  $filter: ModelMonthlyStatusReportFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncMonthlyStatusReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityID
      entityType
      month
      year
      numOccupied
      numVacant
      numRenovation
      numUnits
      numBuildings
      numProperties
      numServiceRequests
      numAmenities
      numAmenityReservations
      expectedRent
      expectedStayRevenue
      aggregateIncome {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncMonthlyStatusReportsQueryVariables,
  APITypes.SyncMonthlyStatusReportsQuery
>;
export const getMoveExam = /* GraphQL */ `query GetMoveExam($id: ID!) {
  getMoveExam(id: $id) {
    id
    type
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMoveExamQueryVariables,
  APITypes.GetMoveExamQuery
>;
export const listMoveExams = /* GraphQL */ `query ListMoveExams(
  $filter: ModelMoveExamFilterInput
  $limit: Int
  $nextToken: String
) {
  listMoveExams(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      status
      userID
      ownerID
      ownerType
      startDate
      endDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMoveExamsQueryVariables,
  APITypes.ListMoveExamsQuery
>;
export const syncMoveExams = /* GraphQL */ `query SyncMoveExams(
  $filter: ModelMoveExamFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncMoveExams(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      type
      status
      userID
      ownerID
      ownerType
      startDate
      endDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncMoveExamsQueryVariables,
  APITypes.SyncMoveExamsQuery
>;
export const getOffer = /* GraphQL */ `query GetOffer($id: ID!) {
  getOffer(id: $id) {
    id
    status
    rent
    userID
    ownerID
    ownerType
    startDate
    tenantSignDate
    landlordSignDate
    endDate
    rentCycle
    normalizedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetOfferQueryVariables, APITypes.GetOfferQuery>;
export const listOffers = /* GraphQL */ `query ListOffers(
  $filter: ModelOfferFilterInput
  $limit: Int
  $nextToken: String
) {
  listOffers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      rent
      userID
      ownerID
      ownerType
      startDate
      tenantSignDate
      landlordSignDate
      endDate
      rentCycle
      normalizedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOffersQueryVariables,
  APITypes.ListOffersQuery
>;
export const syncOffers = /* GraphQL */ `query SyncOffers(
  $filter: ModelOfferFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOffers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      status
      rent
      userID
      ownerID
      ownerType
      startDate
      tenantSignDate
      landlordSignDate
      endDate
      rentCycle
      normalizedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOffersQueryVariables,
  APITypes.SyncOffersQuery
>;
export const getOrganization = /* GraphQL */ `query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationQueryVariables,
  APITypes.GetOrganizationQuery
>;
export const listOrganizations = /* GraphQL */ `query ListOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationsQueryVariables,
  APITypes.ListOrganizationsQuery
>;
export const syncOrganizations = /* GraphQL */ `query SyncOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOrganizations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOrganizationsQueryVariables,
  APITypes.SyncOrganizationsQuery
>;
export const getParcel = /* GraphQL */ `query GetParcel($id: ID!) {
  getParcel(id: $id) {
    id
    propertyID
    status
    name
    description
    areaSize
    boundaryNote
    rent
    price
    userID
    ownerID
    ownerType
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetParcelQueryVariables, APITypes.GetParcelQuery>;
export const listParcels = /* GraphQL */ `query ListParcels(
  $filter: ModelParcelFilterInput
  $limit: Int
  $nextToken: String
) {
  listParcels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      propertyID
      status
      name
      description
      areaSize
      boundaryNote
      rent
      price
      userID
      ownerID
      ownerType
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListParcelsQueryVariables,
  APITypes.ListParcelsQuery
>;
export const syncParcels = /* GraphQL */ `query SyncParcels(
  $filter: ModelParcelFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncParcels(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyID
      status
      name
      description
      areaSize
      boundaryNote
      rent
      price
      userID
      ownerID
      ownerType
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncParcelsQueryVariables,
  APITypes.SyncParcelsQuery
>;
export const getPaymentReceipt = /* GraphQL */ `query GetPaymentReceipt($id: ID!) {
  getPaymentReceipt(id: $id) {
    id
    transactionID
    status
    failureReason
    s3Key
    s3Keys
    ownerID
    ownerType
    signedByUserID
    signedByUserName
    generatedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaymentReceiptQueryVariables,
  APITypes.GetPaymentReceiptQuery
>;
export const listPaymentReceipts = /* GraphQL */ `query ListPaymentReceipts(
  $filter: ModelPaymentReceiptFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaymentReceipts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      transactionID
      status
      failureReason
      s3Key
      s3Keys
      ownerID
      ownerType
      signedByUserID
      signedByUserName
      generatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaymentReceiptsQueryVariables,
  APITypes.ListPaymentReceiptsQuery
>;
export const syncPaymentReceipts = /* GraphQL */ `query SyncPaymentReceipts(
  $filter: ModelPaymentReceiptFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPaymentReceipts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      transactionID
      status
      failureReason
      s3Key
      s3Keys
      ownerID
      ownerType
      signedByUserID
      signedByUserName
      generatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPaymentReceiptsQueryVariables,
  APITypes.SyncPaymentReceiptsQuery
>;
export const getProperty = /* GraphQL */ `query GetProperty($id: ID!) {
  getProperty(id: $id) {
    id
    name
    userID
    ownerID
    ownerType
    description
    areaSize
    street
    city
    state
    country
    zipCode
    contact
    expectedRentPaymentDate
    poBox
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPropertyQueryVariables,
  APITypes.GetPropertyQuery
>;
export const listProperties = /* GraphQL */ `query ListProperties(
  $filter: ModelPropertyFilterInput
  $limit: Int
  $nextToken: String
) {
  listProperties(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      userID
      ownerID
      ownerType
      description
      areaSize
      street
      city
      state
      country
      zipCode
      contact
      expectedRentPaymentDate
      poBox
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPropertiesQueryVariables,
  APITypes.ListPropertiesQuery
>;
export const syncProperties = /* GraphQL */ `query SyncProperties(
  $filter: ModelPropertyFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProperties(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      userID
      ownerID
      ownerType
      description
      areaSize
      street
      city
      state
      country
      zipCode
      contact
      expectedRentPaymentDate
      poBox
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPropertiesQueryVariables,
  APITypes.SyncPropertiesQuery
>;
export const getResourceLifeAccessRight = /* GraphQL */ `query GetResourceLifeAccessRight($id: ID!) {
  getResourceLifeAccessRight(id: $id) {
    id
    resourceType
    createAccessStatus
    createAccessApproverID
    createAccessApprovalDate
    deleteAccessStatus
    deleteAccessApproverID
    deleteAccessApprovalDate
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourceLifeAccessRightQueryVariables,
  APITypes.GetResourceLifeAccessRightQuery
>;
export const listResourceLifeAccessRights = /* GraphQL */ `query ListResourceLifeAccessRights(
  $filter: ModelResourceLifeAccessRightFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceLifeAccessRights(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceType
      createAccessStatus
      createAccessApproverID
      createAccessApprovalDate
      deleteAccessStatus
      deleteAccessApproverID
      deleteAccessApprovalDate
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceLifeAccessRightsQueryVariables,
  APITypes.ListResourceLifeAccessRightsQuery
>;
export const syncResourceLifeAccessRights = /* GraphQL */ `query SyncResourceLifeAccessRights(
  $filter: ModelResourceLifeAccessRightFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncResourceLifeAccessRights(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      resourceType
      createAccessStatus
      createAccessApproverID
      createAccessApprovalDate
      deleteAccessStatus
      deleteAccessApproverID
      deleteAccessApprovalDate
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncResourceLifeAccessRightsQueryVariables,
  APITypes.SyncResourceLifeAccessRightsQuery
>;
export const getResourceUpdateAccessRight = /* GraphQL */ `query GetResourceUpdateAccessRight($id: ID!) {
  getResourceUpdateAccessRight(id: $id) {
    id
    resourceType
    resourceID
    userID
    ownerID
    ownerType
    readAccessStatus
    readAccessApproverID
    readAccessApprovalDate
    writeAccessStatus
    writeAccessApproverID
    writeAccessApprovalDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourceUpdateAccessRightQueryVariables,
  APITypes.GetResourceUpdateAccessRightQuery
>;
export const listResourceUpdateAccessRights = /* GraphQL */ `query ListResourceUpdateAccessRights(
  $filter: ModelResourceUpdateAccessRightFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceUpdateAccessRights(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      resourceType
      resourceID
      userID
      ownerID
      ownerType
      readAccessStatus
      readAccessApproverID
      readAccessApprovalDate
      writeAccessStatus
      writeAccessApproverID
      writeAccessApprovalDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceUpdateAccessRightsQueryVariables,
  APITypes.ListResourceUpdateAccessRightsQuery
>;
export const syncResourceUpdateAccessRights = /* GraphQL */ `query SyncResourceUpdateAccessRights(
  $filter: ModelResourceUpdateAccessRightFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncResourceUpdateAccessRights(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      resourceType
      resourceID
      userID
      ownerID
      ownerType
      readAccessStatus
      readAccessApproverID
      readAccessApprovalDate
      writeAccessStatus
      writeAccessApproverID
      writeAccessApprovalDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncResourceUpdateAccessRightsQueryVariables,
  APITypes.SyncResourceUpdateAccessRightsQuery
>;
export const getServiceRequest = /* GraphQL */ `query GetServiceRequest($id: ID!) {
  getServiceRequest(id: $id) {
    id
    entityID
    entityType
    creatorID
    description
    title
    type
    isUpgrade
    status
    emergency
    userID
    ownerID
    ownerType
    creatorName
    handlerID
    handlerName
    watcherID
    watcherName
    tenantID
    tenantName
    contractor
    dateCreated
    dateUpdated
    estimatedCost
    finalCost
    images
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetServiceRequestQueryVariables,
  APITypes.GetServiceRequestQuery
>;
export const listServiceRequests = /* GraphQL */ `query ListServiceRequests(
  $filter: ModelServiceRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  listServiceRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entityID
      entityType
      creatorID
      description
      title
      type
      isUpgrade
      status
      emergency
      userID
      ownerID
      ownerType
      creatorName
      handlerID
      handlerName
      watcherID
      watcherName
      tenantID
      tenantName
      contractor
      dateCreated
      dateUpdated
      estimatedCost
      finalCost
      images
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListServiceRequestsQueryVariables,
  APITypes.ListServiceRequestsQuery
>;
export const syncServiceRequests = /* GraphQL */ `query SyncServiceRequests(
  $filter: ModelServiceRequestFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncServiceRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityID
      entityType
      creatorID
      description
      title
      type
      isUpgrade
      status
      emergency
      userID
      ownerID
      ownerType
      creatorName
      handlerID
      handlerName
      watcherID
      watcherName
      tenantID
      tenantName
      contractor
      dateCreated
      dateUpdated
      estimatedCost
      finalCost
      images
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncServiceRequestsQueryVariables,
  APITypes.SyncServiceRequestsQuery
>;
export const getStay = /* GraphQL */ `query GetStay($id: ID!) {
  getStay(id: $id) {
    id
    entityType
    entityID
    checkIn
    checkOut
    status
    tenantID
    nightlyRate
    totalAmount
    currency
    notes
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetStayQueryVariables, APITypes.GetStayQuery>;
export const listStays = /* GraphQL */ `query ListStays(
  $filter: ModelStayFilterInput
  $limit: Int
  $nextToken: String
) {
  listStays(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entityType
      entityID
      checkIn
      checkOut
      status
      tenantID
      nightlyRate
      totalAmount
      currency
      notes
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListStaysQueryVariables, APITypes.ListStaysQuery>;
export const syncStays = /* GraphQL */ `query SyncStays(
  $filter: ModelStayFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncStays(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityType
      entityID
      checkIn
      checkOut
      status
      tenantID
      nightlyRate
      totalAmount
      currency
      notes
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncStaysQueryVariables, APITypes.SyncStaysQuery>;
export const getStayRate = /* GraphQL */ `query GetStayRate($id: ID!) {
  getStayRate(id: $id) {
    id
    entityType
    entityID
    nightlyRate
    weeklyRate
    minNights
    maxNights
    cleaningFee
    currency
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStayRateQueryVariables,
  APITypes.GetStayRateQuery
>;
export const listStayRates = /* GraphQL */ `query ListStayRates(
  $filter: ModelStayRateFilterInput
  $limit: Int
  $nextToken: String
) {
  listStayRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entityType
      entityID
      nightlyRate
      weeklyRate
      minNights
      maxNights
      cleaningFee
      currency
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStayRatesQueryVariables,
  APITypes.ListStayRatesQuery
>;
export const syncStayRates = /* GraphQL */ `query SyncStayRates(
  $filter: ModelStayRateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncStayRates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityType
      entityID
      nightlyRate
      weeklyRate
      minNights
      maxNights
      cleaningFee
      currency
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncStayRatesQueryVariables,
  APITypes.SyncStayRatesQuery
>;
export const getStayAvailability = /* GraphQL */ `query GetStayAvailability($id: ID!) {
  getStayAvailability(id: $id) {
    id
    entityType
    entityID
    start
    end
    reason
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStayAvailabilityQueryVariables,
  APITypes.GetStayAvailabilityQuery
>;
export const listStayAvailabilities = /* GraphQL */ `query ListStayAvailabilities(
  $filter: ModelStayAvailabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  listStayAvailabilities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      entityType
      entityID
      start
      end
      reason
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStayAvailabilitiesQueryVariables,
  APITypes.ListStayAvailabilitiesQuery
>;
export const syncStayAvailabilities = /* GraphQL */ `query SyncStayAvailabilities(
  $filter: ModelStayAvailabilityFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncStayAvailabilities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      entityType
      entityID
      start
      end
      reason
      userID
      ownerID
      ownerType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncStayAvailabilitiesQueryVariables,
  APITypes.SyncStayAvailabilitiesQuery
>;
export const getSubscriptionDiscount = /* GraphQL */ `query GetSubscriptionDiscount($id: ID!) {
  getSubscriptionDiscount(id: $id) {
    id
    planID
    startDate
    endDate
    percentage
    isActive
    codeID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionDiscountQueryVariables,
  APITypes.GetSubscriptionDiscountQuery
>;
export const listSubscriptionDiscounts = /* GraphQL */ `query ListSubscriptionDiscounts(
  $filter: ModelSubscriptionDiscountFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionDiscounts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      planID
      startDate
      endDate
      percentage
      isActive
      codeID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionDiscountsQueryVariables,
  APITypes.ListSubscriptionDiscountsQuery
>;
export const syncSubscriptionDiscounts = /* GraphQL */ `query SyncSubscriptionDiscounts(
  $filter: ModelSubscriptionDiscountFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSubscriptionDiscounts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      planID
      startDate
      endDate
      percentage
      isActive
      codeID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSubscriptionDiscountsQueryVariables,
  APITypes.SyncSubscriptionDiscountsQuery
>;
export const getSubscriptionDiscountCode = /* GraphQL */ `query GetSubscriptionDiscountCode($id: ID!) {
  getSubscriptionDiscountCode(id: $id) {
    id
    code
    userID
    usageCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionDiscountCodeQueryVariables,
  APITypes.GetSubscriptionDiscountCodeQuery
>;
export const listSubscriptionDiscountCodes = /* GraphQL */ `query ListSubscriptionDiscountCodes(
  $filter: ModelSubscriptionDiscountCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionDiscountCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      code
      userID
      usageCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionDiscountCodesQueryVariables,
  APITypes.ListSubscriptionDiscountCodesQuery
>;
export const syncSubscriptionDiscountCodes = /* GraphQL */ `query SyncSubscriptionDiscountCodes(
  $filter: ModelSubscriptionDiscountCodeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSubscriptionDiscountCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      code
      userID
      usageCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSubscriptionDiscountCodesQueryVariables,
  APITypes.SyncSubscriptionDiscountCodesQuery
>;
export const getSubscriptionLink = /* GraphQL */ `query GetSubscriptionLink($id: ID!) {
  getSubscriptionLink(id: $id) {
    id
    userID
    planID
    startDate
    endDate
    renewalType
    autoRenewal
    nextPaymentAmount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionLinkQueryVariables,
  APITypes.GetSubscriptionLinkQuery
>;
export const listSubscriptionLinks = /* GraphQL */ `query ListSubscriptionLinks(
  $filter: ModelSubscriptionLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      planID
      startDate
      endDate
      renewalType
      autoRenewal
      nextPaymentAmount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionLinksQueryVariables,
  APITypes.ListSubscriptionLinksQuery
>;
export const syncSubscriptionLinks = /* GraphQL */ `query SyncSubscriptionLinks(
  $filter: ModelSubscriptionLinkFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSubscriptionLinks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      planID
      startDate
      endDate
      renewalType
      autoRenewal
      nextPaymentAmount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSubscriptionLinksQueryVariables,
  APITypes.SyncSubscriptionLinksQuery
>;
export const getSubscriptionPlan = /* GraphQL */ `query GetSubscriptionPlan($id: ID!) {
  getSubscriptionPlan(id: $id) {
    id
    name
    description
    price
    isActive
    features
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionPlanQueryVariables,
  APITypes.GetSubscriptionPlanQuery
>;
export const listSubscriptionPlans = /* GraphQL */ `query ListSubscriptionPlans(
  $filter: ModelSubscriptionPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      price
      isActive
      features
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionPlansQueryVariables,
  APITypes.ListSubscriptionPlansQuery
>;
export const syncSubscriptionPlans = /* GraphQL */ `query SyncSubscriptionPlans(
  $filter: ModelSubscriptionPlanFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSubscriptionPlans(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      price
      isActive
      features
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSubscriptionPlansQueryVariables,
  APITypes.SyncSubscriptionPlansQuery
>;
export const getTenant = /* GraphQL */ `query GetTenant($id: ID!) {
  getTenant(id: $id) {
    id
    authUID
    username
    firstName
    middleName
    lastName
    userID
    ownerID
    ownerType
    status
    type
    phoneNumber
    jobTitle
    jobPhone
    jobEmail
    jobContactName
    income
    cimesCommitted
    jailTime
    lastArrest
    lastUpdated
    totalCredit
    employer
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTenantQueryVariables, APITypes.GetTenantQuery>;
export const listTenants = /* GraphQL */ `query ListTenants(
  $filter: ModelTenantFilterInput
  $limit: Int
  $nextToken: String
) {
  listTenants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      authUID
      username
      firstName
      middleName
      lastName
      userID
      ownerID
      ownerType
      status
      type
      phoneNumber
      jobTitle
      jobPhone
      jobEmail
      jobContactName
      income
      cimesCommitted
      jailTime
      lastArrest
      lastUpdated
      totalCredit
      employer
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTenantsQueryVariables,
  APITypes.ListTenantsQuery
>;
export const syncTenants = /* GraphQL */ `query SyncTenants(
  $filter: ModelTenantFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTenants(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      authUID
      username
      firstName
      middleName
      lastName
      userID
      ownerID
      ownerType
      status
      type
      phoneNumber
      jobTitle
      jobPhone
      jobEmail
      jobContactName
      income
      cimesCommitted
      jailTime
      lastArrest
      lastUpdated
      totalCredit
      employer
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTenantsQueryVariables,
  APITypes.SyncTenantsQuery
>;
export const getTransaction = /* GraphQL */ `query GetTransaction($id: ID!) {
  getTransaction(id: $id) {
    id
    amount
    reason
    currency
    entityID
    entityType
    userID
    ownerID
    ownerType
    month
    year
    periodStart
    periodEnd
    tenantID
    managerID
    status
    dateSent
    dateReceived
    paymentMethod
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionQueryVariables,
  APITypes.GetTransactionQuery
>;
export const listTransactions = /* GraphQL */ `query ListTransactions(
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amount
      reason
      currency
      entityID
      entityType
      userID
      ownerID
      ownerType
      month
      year
      periodStart
      periodEnd
      tenantID
      managerID
      status
      dateSent
      dateReceived
      paymentMethod
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsQueryVariables,
  APITypes.ListTransactionsQuery
>;
export const syncTransactions = /* GraphQL */ `query SyncTransactions(
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTransactions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      amount
      reason
      currency
      entityID
      entityType
      userID
      ownerID
      ownerType
      month
      year
      periodStart
      periodEnd
      tenantID
      managerID
      status
      dateSent
      dateReceived
      paymentMethod
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTransactionsQueryVariables,
  APITypes.SyncTransactionsQuery
>;
export const getUnitPlan = /* GraphQL */ `query GetUnitPlan($id: ID!) {
  getUnitPlan(id: $id) {
    id
    propertyID
    name
    description
    numBedroom
    numBathroom
    size
    userID
    ownerID
    ownerType
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUnitPlanQueryVariables,
  APITypes.GetUnitPlanQuery
>;
export const listUnitPlans = /* GraphQL */ `query ListUnitPlans(
  $filter: ModelUnitPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listUnitPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      propertyID
      name
      description
      numBedroom
      numBathroom
      size
      userID
      ownerID
      ownerType
      inUnitLaundry
      dishwasher
      airConditioning
      furnished
      balcony
      petFriendly
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitPlansQueryVariables,
  APITypes.ListUnitPlansQuery
>;
export const syncUnitPlans = /* GraphQL */ `query SyncUnitPlans(
  $filter: ModelUnitPlanFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUnitPlans(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      propertyID
      name
      description
      numBedroom
      numBathroom
      size
      userID
      ownerID
      ownerType
      inUnitLaundry
      dishwasher
      airConditioning
      furnished
      balcony
      petFriendly
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUnitPlansQueryVariables,
  APITypes.SyncUnitPlansQuery
>;
export const getUnit = /* GraphQL */ `query GetUnit($id: ID!) {
  getUnit(id: $id) {
    id
    status
    name
    rent
    price
    numBedroom
    numBathroom
    buildingID
    userID
    ownerID
    ownerType
    description
    availabilityDate
    actualRentPaymentDate
    activeLeaseID
    type
    unitPlanID
    size
    street
    deposit
    additionalFees
    feesDescription
    tenantID
    contact
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUnitQueryVariables, APITypes.GetUnitQuery>;
export const listUnits = /* GraphQL */ `query ListUnits(
  $filter: ModelUnitFilterInput
  $limit: Int
  $nextToken: String
) {
  listUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      rent
      price
      numBedroom
      numBathroom
      buildingID
      userID
      ownerID
      ownerType
      description
      availabilityDate
      actualRentPaymentDate
      activeLeaseID
      type
      unitPlanID
      size
      street
      deposit
      additionalFees
      feesDescription
      tenantID
      contact
      inUnitLaundry
      dishwasher
      airConditioning
      furnished
      balcony
      petFriendly
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUnitsQueryVariables, APITypes.ListUnitsQuery>;
export const syncUnits = /* GraphQL */ `query SyncUnits(
  $filter: ModelUnitFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUnits(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      status
      name
      rent
      price
      numBedroom
      numBathroom
      buildingID
      userID
      ownerID
      ownerType
      description
      availabilityDate
      actualRentPaymentDate
      activeLeaseID
      type
      unitPlanID
      size
      street
      deposit
      additionalFees
      feesDescription
      tenantID
      contact
      inUnitLaundry
      dishwasher
      airConditioning
      furnished
      balcony
      petFriendly
      shortTermStayEnabled
      forSaleEnabled
      stayRequireApproval
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncUnitsQueryVariables, APITypes.SyncUnitsQuery>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    authUID
    username
    title
    type
    firstName
    middleName
    lastName
    salary
    companyName
    phoneNumber
    email
    officeAddress
    workingHours
    roles
    organizationID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      authUID
      username
      title
      type
      firstName
      middleName
      lastName
      salary
      companyName
      phoneNumber
      email
      officeAddress
      workingHours
      roles
      organizationID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const syncUsers = /* GraphQL */ `query SyncUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      authUID
      username
      title
      type
      firstName
      middleName
      lastName
      salary
      companyName
      phoneNumber
      email
      officeAddress
      workingHours
      roles
      organizationID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncUsersQueryVariables, APITypes.SyncUsersQuery>;
export const getUserOrganizationConnection = /* GraphQL */ `query GetUserOrganizationConnection($id: ID!) {
  getUserOrganizationConnection(id: $id) {
    id
    userID
    username
    creatorID
    creatorName
    organizationID
    managerID
    managerName
    title
    salary
    ownershipType
    clearanceLevel
    joinedDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserOrganizationConnectionQueryVariables,
  APITypes.GetUserOrganizationConnectionQuery
>;
export const listUserOrganizationConnections = /* GraphQL */ `query ListUserOrganizationConnections(
  $filter: ModelUserOrganizationConnectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserOrganizationConnections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      username
      creatorID
      creatorName
      organizationID
      managerID
      managerName
      title
      salary
      ownershipType
      clearanceLevel
      joinedDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserOrganizationConnectionsQueryVariables,
  APITypes.ListUserOrganizationConnectionsQuery
>;
export const syncUserOrganizationConnections = /* GraphQL */ `query SyncUserOrganizationConnections(
  $filter: ModelUserOrganizationConnectionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserOrganizationConnections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      username
      creatorID
      creatorName
      organizationID
      managerID
      managerName
      title
      salary
      ownershipType
      clearanceLevel
      joinedDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserOrganizationConnectionsQueryVariables,
  APITypes.SyncUserOrganizationConnectionsQuery
>;
export const getYearlyReportSummary = /* GraphQL */ `query GetYearlyReportSummary($id: ID!) {
  getYearlyReportSummary(id: $id) {
    id
    userID
    ownerID
    ownerType
    year
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetYearlyReportSummaryQueryVariables,
  APITypes.GetYearlyReportSummaryQuery
>;
export const listYearlyReportSummaries = /* GraphQL */ `query ListYearlyReportSummaries(
  $filter: ModelYearlyReportSummaryFilterInput
  $limit: Int
  $nextToken: String
) {
  listYearlyReportSummaries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      ownerID
      ownerType
      year
      entityID
      entityType
      income {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListYearlyReportSummariesQueryVariables,
  APITypes.ListYearlyReportSummariesQuery
>;
export const syncYearlyReportSummaries = /* GraphQL */ `query SyncYearlyReportSummaries(
  $filter: ModelYearlyReportSummaryFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncYearlyReportSummaries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      ownerID
      ownerType
      year
      entityID
      entityType
      income {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncYearlyReportSummariesQueryVariables,
  APITypes.SyncYearlyReportSummariesQuery
>;
export const getYearlyStatusSummary = /* GraphQL */ `query GetYearlyStatusSummary($id: ID!) {
  getYearlyStatusSummary(id: $id) {
    id
    userID
    ownerID
    ownerType
    entityID
    entityType
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetYearlyStatusSummaryQueryVariables,
  APITypes.GetYearlyStatusSummaryQuery
>;
export const listYearlyStatusSummaries = /* GraphQL */ `query ListYearlyStatusSummaries(
  $filter: ModelYearlyStatusSummaryFilterInput
  $limit: Int
  $nextToken: String
) {
  listYearlyStatusSummaries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      ownerID
      ownerType
      entityID
      entityType
      year
      numOccupied
      numVacant
      numRenovation
      numUnits
      numBuildings
      numProperties
      numServiceRequests
      numAmenities
      numAmenityReservations
      expectedRent
      expectedStayRevenue
      aggregateIncome {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListYearlyStatusSummariesQueryVariables,
  APITypes.ListYearlyStatusSummariesQuery
>;
export const syncYearlyStatusSummaries = /* GraphQL */ `query SyncYearlyStatusSummaries(
  $filter: ModelYearlyStatusSummaryFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncYearlyStatusSummaries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      ownerID
      ownerType
      entityID
      entityType
      year
      numOccupied
      numVacant
      numRenovation
      numUnits
      numBuildings
      numProperties
      numServiceRequests
      numAmenities
      numAmenityReservations
      expectedRent
      expectedStayRevenue
      aggregateIncome {
        rentRevenue
        stayRevenue
        feeRevenue
        otherRevenue
        totalRevenue
        repairExpenses
        lostRentExpenses
        renovationExpenses
        totalExpenses
        net
        userID
        ownerID
        ownerType
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncYearlyStatusSummariesQueryVariables,
  APITypes.SyncYearlyStatusSummariesQuery
>;
export const getYearRecords = /* GraphQL */ `query GetYearRecords($id: ID!) {
  getYearRecords(id: $id) {
    id
    userID
    ownerID
    ownerType
    years
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetYearRecordsQueryVariables,
  APITypes.GetYearRecordsQuery
>;
export const listYearRecords = /* GraphQL */ `query ListYearRecords(
  $filter: ModelYearRecordsFilterInput
  $limit: Int
  $nextToken: String
) {
  listYearRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      ownerID
      ownerType
      years
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListYearRecordsQueryVariables,
  APITypes.ListYearRecordsQuery
>;
export const syncYearRecords = /* GraphQL */ `query SyncYearRecords(
  $filter: ModelYearRecordsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncYearRecords(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      ownerID
      ownerType
      years
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncYearRecordsQueryVariables,
  APITypes.SyncYearRecordsQuery
>;
export const paymentReceiptByTransactionID = /* GraphQL */ `query PaymentReceiptByTransactionID(
  $transactionID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPaymentReceiptFilterInput
  $limit: Int
  $nextToken: String
) {
  paymentReceiptByTransactionID(
    transactionID: $transactionID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      transactionID
      status
      failureReason
      s3Key
      s3Keys
      ownerID
      ownerType
      signedByUserID
      signedByUserName
      generatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaymentReceiptByTransactionIDQueryVariables,
  APITypes.PaymentReceiptByTransactionIDQuery
>;
